const MX_MERCHANT_BASE_URL = process.env.REACT_APP_MXM_BASE_URL
// const MX_MERCHANT_BASE_URL = 'https://sandbox.api.mxmerchant.com/checkout/v3/payment'

export const makePayment = async (merchantId, amount, cardNumber, expiryMonth, expiryYear, cvv, zipCode, address) => {

    const requestBody = {
        paymentType: 'Sale',
        authOnly: false,
        isAuth: false,
        cardAccount: {
            number: cardNumber,
            expiryMonth: expiryMonth,
            expiryYear: expiryYear,
            cvv: cvv,
            avsZip: zipCode,
            avsStreet: address
        },
        entryClass: 'WEB',
        isSettleFunds: false,
        source: 'API',
        taxExempt: false,
        surchargeLabel: 'surcharge',
        mxAdvantageEnabled: 'true',
        mxAdvantageFeeLabel: 'surcharge',
        mxAdvantageFeeType: 'percentage',
        merchantId: merchantId,
        amount: amount,
        tenderType: 'Card'
    };

    console.log("Auth: ",process.env.REACT_APP_MXM_AUTHORIZATION)
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_MXM_AUTHORIZATION
            // Authorization: 'Basic VjNJekJqVURCOUdVbFJHZDBrZFNBQVlDOjViZ3dvVU9vU1Fmd21YYjVCVmpqTzQrZjhMVT0='
        },
        body: JSON.stringify(requestBody)
    };

    try {
        if (amount > 0) {
            let response = await fetch(MX_MERCHANT_BASE_URL + '?echo=true&includeCustomerMatches=true', options);
            let data = response.json();
            return data;
        } else {
            console.error('Amount less than 0');
            return null;
        }
    } catch (error) {
        console.error('Error while making payment: ', error);
        return null;
    }
}

export const makeVaultedPayment = async (merchantId, amount, token) => {

    const requestBody = {
        paymentType: 'Sale',
        tenderType: 'Card',
        merchantId: merchantId,
        amount: amount,
        cardAccount: {
            Token: token
        }
    };

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_MXM_AUTHORIZATION
            // Authorization: 'Basic VjNJekJqVURCOUdVbFJHZDBrZFNBQVlDOjViZ3dvVU9vU1Fmd21YYjVCVmpqTzQrZjhMVT0='
        },
        body: JSON.stringify(requestBody)
    };

    try {
        console.log("Making a vaulted payment with token: ", token)
        if (amount > 0) {
            let response = await fetch(MX_MERCHANT_BASE_URL + '?echo=true&includeCustomerMatches=true', options);
            let data = response.json();
            return data;
        } else {
            console.error('Amount less than 0');
            return null;
        }
    } catch (error) {
        console.error('Error while making payment: ', error);
        return null;
    }
}

export const getPayment = async (merchantId, referenceNumber) => {

    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_MXM_AUTHORIZATION
            // Authorization: 'Basic VjNJekJqVURCOUdVbFJHZDBrZFNBQVlDOjViZ3dvVU9vU1Fmd21YYjVCVmpqTzQrZjhMVT0='
        }
    };

    try {
        let response = await fetch(MX_MERCHANT_BASE_URL + '?merchantId=' + merchantId + '&includeCustomer=true&filter=' + referenceNumber, options);
        let data = response.json();
        console.log(data);
        return data;
    } catch (error) {
        console.error('Error while get payment: ', error);
        return null;
    }
}

export const returnVoid = async (id) => {

    const options = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_MXM_AUTHORIZATION
            // Authorization: 'Basic VjNJekJqVURCOUdVbFJHZDBrZFNBQVlDOjViZ3dvVU9vU1Fmd21YYjVCVmpqTzQrZjhMVT0='
        }
    };

    try {
        let response = await fetch(MX_MERCHANT_BASE_URL + '/' + id + '?force=true', options);
        let data = response;
        console.log(data);
        return data;
    } catch (error) {
        console.error('Error while voiding payment: ', error);
        return null;
    }
}

export const partialRefund = async (merchantId, amount, token) => {

    const requestBody = {
        merchantId: merchantId,
        amount: amount,
        tenderType: 'Card',
        paymentToken: token
    };

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_MXM_AUTHORIZATION
            // Authorization: 'Basic VjNJekJqVURCOUdVbFJHZDBrZFNBQVlDOjViZ3dvVU9vU1Fmd21YYjVCVmpqTzQrZjhMVT0='
        },
        body: JSON.stringify(requestBody)
    };

    try {
        let response = await fetch(MX_MERCHANT_BASE_URL + '?echo=true', options);
        let data = response.json();
        return data;
    } catch (error) {
        console.error('Error while making payment: ', error);
        return null;
    }
}

export const getJWTToken = async (merchantId) => {

    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_MXM_AUTHORIZATION
            // Authorization: 'Basic VjNJekJqVURCOUdVbFJHZDBrZFNBQVlDOjViZ3dvVU9vU1Fmd21YYjVCVmpqTzQrZjhMVT0='
        }
    };

    try {
        let response = await fetch('https://api2.mxmerchant.com/security/v1/application/merchantId/' + merchantId + '/token', options);
        let data = response.json();
        return data;
    } catch (error) {
        console.error('Error while making payment: ', error);
        return null;
    }
}

export const getListOfTerminals = async (merchantId, token) => {

    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        }
    };

    try {
        let response = await fetch('https://api2.mxmerchant.com/terminal/v1/merchantid/' + merchantId, options);
        let data = response.json();
        return data;
    } catch (error) {
        console.error('Error while making payment: ', error);
        return null;
    }
}

export const createTerminalPayment = async (merchantId, token, amount, terminalId, replayId) => {
    const requestBody = {
        amount: parseFloat(amount),
        type: 'Sale',
        vaultcard: false,
        replayId: String(replayId)
    };

    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token
        },
        body: JSON.stringify(requestBody)
    };

    try {
        console.log("Options: ",options)
        let response = await fetch('https://api2.mxmerchant.com/terminal/v1/transaction/merchantid/' + merchantId+ '/terminalid/' + terminalId, options);
        let data = response.json();
        return data;
    } catch (error) {
        console.error('Error while making payment: ', error);
        return null;
    }
}

export const getTerminalTransaction = async (merchantId, replayId) => {
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: process.env.REACT_APP_MXM_AUTHORIZATION
            // Authorization: 'Basic VjNJekJqVURCOUdVbFJHZDBrZFNBQVlDOjViZ3dvVU9vU1Fmd21YYjVCVmpqTzQrZjhMVT0='
        },
    };

    const maxRetries = 30;
    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const url = `https://api.mxmerchant.com/checkout/v3/payment?merchantId=${merchantId}&replayId=${replayId}`;
            const response = await fetch(url, options);

            if (response.status === 404) {
                console.warn(`Attempt ${attempt}: Received 404, retrying in 2 seconds...`);
                await delay(2000);
                continue;
            }

            if (!response.ok) {
                console.error(`Attempt ${attempt}: HTTP error ${response.status}`);
                return null;
            }

            const data = await response.json();
            return data;

        } catch (error) {
            console.error(`Attempt ${attempt}: Error while making payment:`, error);
            await delay(2000);
        }
    }

    console.error('Max retries reached. Giving up.');
    return null;
};
